import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { OverChargeClaimEmail } from '../../types';

export const getClaimEmailNotificationAPI = (FBOCKey: number) => {
  return axiosInstance.request({
    method: 'get',
    params: { FBOCKey },
    url: `${API.OVERCHARGE_CLAIM}/GetClaimEmailNotification`,
  });
};

export interface GetClaimEmailNotificationResponse {
  claimEmails: OverChargeClaimEmail[];
}

export const fetchClaimEmailNotifications = async (FBOCKey: number): Promise<OverChargeClaimEmail[]> => {
  const response: AxiosResponse<GetClaimEmailNotificationResponse> = await getClaimEmailNotificationAPI(FBOCKey);
  return response.data.claimEmails ?? [];
};

export interface SendOCClaimPdfToCarrierRequestBody {
  attachment: string;
  carrierKey: number;
  customEmailAddress: string | null;
  fbocKey: number;
  isCustom: number;
  self: number;
}

export const sendMailToTransportationProviderAPI = (data: SendOCClaimPdfToCarrierRequestBody) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.OVERCHARGE_CLAIM}/SendMailToTransportationProvider`,
  });
};

export const sendOCClaimPdfToCarrier = async (data: SendOCClaimPdfToCarrierRequestBody): Promise<unknown> => {
  const response = await sendMailToTransportationProviderAPI(data);
  return response.data;
};
